import BadgeXSvg from '@assets/images/svg/badge-x.svg';
import React from 'react';
import { View } from 'react-native';

export interface BadgeXIconProps {
    size?: number;
    color?: string;
}

export function BadgeXIcon({ size = 30, color = 'white' }: BadgeXIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <BadgeXSvg width={size} height={size} color={color} />
        </View>
    );
}
